export default __webpack_public_path__ + "static/media/spiced-mint.67f166d4.png";